import { render, staticRenderFns } from "./KBDiffView.vue?vue&type=template&id=8d39c2c2&scoped=true&lang=pug"
import script from "./KBDiffView.vue?vue&type=script&lang=js"
export * from "./KBDiffView.vue?vue&type=script&lang=js"
import style0 from "./KBDiffView.vue?vue&type=style&index=0&id=8d39c2c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d39c2c2",
  null
  
)

export default component.exports